
import _ from 'lodash';

import template from './resourceManagement.modal.component.html';

/* @ngInject */
function controller(
  $uibModalInstance,
  $scope,
  resourceList,
  GroupService,
  GroupsButtonService,
  growl,
  Organization,
  TypeService
) {
  const vm = this;
  vm.heading = 'New Resource List';
  vm.name = '';
  vm.selectedGroups = [];
  vm.groupList = [];
  vm.orgs = [];
  vm.model = 'resourceList';
  vm.formSchema = {};
  vm.growl = growl;
  vm.formModel = {};
  vm.setupOrgs = setupOrgs;
  vm.setupGroups = setupGroups;
  vm.formOptions = {
    title: 'Resource Schema',
    buildFromSchema: true,
    hideAdvanced: true,
    enableBuilder: false,
    showBuilder: false,
    readOnly: true,
  };

  vm.$onInit = initialize;

  vm.editing = Boolean(resourceList);

  if (vm.editing) {
    // TODO: Consolidate these assignments with the declarations above
    vm.heading = `Editing ${resourceList.name}`;
    vm.name = resourceList.name;
    vm.model = resourceList.model;
    vm.type = resourceList.type;
    vm.org = resourceList.org;
  }

  /**
   * function that's called onInit (angularJS lifecycle hook)
   *
   * @returns {undefined}
   */
  async function initialize() {
    const formSchema = _.get(resourceList, ['formSchema'], { components: [] });
    vm.types = await TypeService.getAllTypes();
    // pluck out the inner components from the `data` container/object for user to edit schema
    // without causing a change in the resourceList structure
    if (formSchema.components?.length === 1 && formSchema.components[0].key === 'data') {
      formSchema.components = _.cloneDeep(formSchema.components[0].components);
    }
    vm.formSchema = formSchema;

    if (vm.type) {
      setupOrgs();
    }

    if (vm.org) {
      setupGroups();
    }
  }

  async function setupOrgs() {
    const result = await TypeService.getType(vm.type);
    const org = result.body.org;
    Organization.getOrgsManagedByOrg(org)
      .then(({ body }) => {
        vm.orgs = body;
        if (vm.editing) {
          vm.selectedOrg = resourceList.org;
        }
        $scope.$apply();
      }).catch((error) => {
        growl.error(error, { title: 'Could not get orgs for selected type' });
      });
  }

  function setupGroups() {
    GroupService.getGroupByOrg(vm.org, 1).then(({ body }) => {
      vm.groupList = [body];
      if (vm.editing) {
        vm.selectedGroups = resourceList.groups;
      }
    }).catch((error) => {
      growl.error(error, { title: 'Could not get groups for selected organization' });
    });
  }

  /**
   * Checks to see if selectedGroups is empty.
   *
   * @returns {number} - returns size of selectedGroups. Caller checks truthiness of size.
   */
  vm.validateGroups = () => _.size(GroupsButtonService.cache.selectedGroupsTree);

  /**
   * calls when the save button is pressed on the modal. Closes the modal
   *
   * @returns {undefined}
   */
  vm.save = () => {
    $uibModalInstance.close(_.assign(resourceList, getResourceList()));
  };

  vm.updateForm = ($event) => {
    $scope.$apply(() => {
      vm.formSchema = $event;
    });
  };

  /**
   * Calls when you hit the cancel or X on the modal
   *
   * @returns {undefined}
   */
  vm.dismiss = function dismiss() {
    $uibModalInstance.dismiss('closed');
  };

  function getResourceList() {
    const {
      name,
      org,
      model,
      type,
      formSchema,
    } = vm;

    // wrap the user-defined components in a `data` container/object before saving
    // reproduces the stored structure of resources, without letting a user inadvertently delete the container
    formSchema.components = [{
      key: 'data',
      label: 'data',
      hideLabel: true,
      type: 'container',
      components: formSchema.components
    }];

    return {
      name,
      model,
      org,
      formSchema,
      type,
      groups: GroupsButtonService.rebuildSelectedGroups()
    };
  }

}

export default {
  name: 'resourceManagementModal',
  template,
  controller,
  controllerAs: 'modal',
  bindings: {
    resourceList: '<'
  }
};
